'use client';

import { Box, Text } from '@instamenu/ui-system-next';
import * as styles from './address-select.css';
import type { Address } from '@instamenu/context-user';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { palette } from '@instamenu/ui-vanilla-extract';
import { CardButton } from '../card-button/card-button';

type AddressButtonProps = {
  address?: Address;
  isOpen: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const AddressCard = ({ address, isOpen, ...rest }: AddressButtonProps) => {
  const checkout = useCheckoutContext();

  return (
    <CardButton onClick={rest.onClick} isOpen={isOpen}>
      <Box
        data-id="address-card"
        css={{ display: 'flex', alignItems: 'flex-start', gap: 8, flex: 1 }}
      >
        {address ? (
          <Box css={{ flex: 1, minWidth: 0 }}>
            <Box
              css={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                marginBottom: 4,
              }}
            >
              <Text
                wordBreak
                variant="subtitle2"
                css={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: '16px',
                  lineHeight: '32px',
                  fontWeight: '400',
                }}
              >
                {address.line1}
              </Text>
            </Box>
            <Text
              variant="caption2"
              maxLines={2}
              wordBreak
              css={{ color: palette.gray500, marginTop: -8 }}
            >
              {address.json.specialInstructions}
            </Text>
          </Box>
        ) : (
          <Text variant="caption2" className={styles.textAddress}>
            {checkout?.addresses.book.length ? 'Select an address' : 'Enter your address'}
          </Text>
        )}
      </Box>
    </CardButton>
  );
};
